<template>
  <div class="modal-container clearfix">
    <vxe-form
        style="margin-top: 20px"
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="110"
        :data="formData"
        :rules="formRules">
      <vxe-form-item title="查询时长" field="countTrackMonthManage" span="24">
        <template>
          <div class="flex">
            <vxe-input v-model="formData.countTrackMonthManage" style="width: 200px;"></vxe-input>
            月
          </div>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="modal-footer add-btn-box">
      <Button @click="close" style="border-radius: 5px;">取 消</Button>
      <Button type="primary" style="border-radius: 5px;" @click="commit">确 定</Button>
    </div>
  </div>
</template>
<script>

import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  props: ['userId'],
  data() {
    return {
      formData: {
        id: null,
        taxComp: null,
      },
      formRules: {
        countTrackMonthManage: [{required: true, message: "请输入查询时长"}],
      }
    }
  },
  methods: {
    init(month) {
      this.$set(this.formData, 'countTrackMonthManage', month);
    },
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async commit() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }
      this.editUserTrackMonthManage();
    },
    async editUserTrackMonthManage() {
      showLoading();
      let res = await $api.seachart.request("editUserTrackMonthManage", {
        userId: this.userId,
        countTrackMonthManage: this.formData.countTrackMonthManage
      });
      hideLoading();
      if (res.code === 1) {
        this.$Message.success("配置成功");
        this.$emit('afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close(){
      this.$emit('afterSave');
    }
  }
}
</script>
<style scoped>
.modal-footer {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
}

.flex {
  display: flex;
  align-items: center;
}
</style>